import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { BoqVersionPage } from '@/features/cost/boq-version-page';

const searchSchema = z.object({ version: z.string().optional().catch(undefined) });

export const Route = createFileRoute('/_app/projects/$projectId/cost/boq/$boqId')({
  validateSearch: searchSchema,
  component: BoqRoute,
});

function BoqRoute() {
  const { projectId, boqId } = Route.useParams();
  const { version } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <BoqVersionPage
      projectId={projectId}
      boqId={boqId}
      versionId={version}
      onVersion={(next) => void navigate({ search: { version: next }, replace: true })}
    />
  );
}
